/* eslint-disable no-console */
import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Col, Form, Popconfirm, Row} from 'antd';
import React, {useRef} from 'react';

const FormListComp: React.FC<{
  mainName: any;
  formComponent: React.ReactElement;
}> = ({mainName, formComponent}) => {
  const addButtonRef = useRef<any>(null);

  const scrollToAddButton = () => {
    if (addButtonRef?.current) {
      setTimeout(() => {
        addButtonRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start' // Scroll to the top of the button
        });
      }, 100); // Ensure the DOM updates before scrolling
    }
  };

  return (
    <>
      <Form.List name={mainName} initialValue={[{}]}>
        {(fields, {add, remove}) => (
          <>
            {fields?.map(({key, name}) => (
              <Row
                key={key}
                gutter={[16, 8]}
                style={{width: '100%'}}
                // style={{
                //   display: 'flex',
                //   flexDirection: 'column',
                //   gap: '10px',
                //   alignItems: 'center'
                // }}
              >
                {React.cloneElement(formComponent, {
                  name,
                  key,
                  fields,
                  mainName
                })}
                {fields.length > 1 && (
                  <Col span={12} offset={10}>
                    <Popconfirm
                      onConfirm={() => {
                        remove(name);
                      }}
                      title="Sure to Delete?"
                    >
                      <Button
                        icon={<MinusOutlined />}
                        className="removeButton"
                        style={{marginBottom: '16px'}}
                      >
                        Remove
                      </Button>
                    </Popconfirm>
                  </Col>
                )}
              </Row>
            ))}
            <Button
              id="addButton"
              ref={addButtonRef}
              icon={<PlusOutlined />}
              className="removeButton"
              onClick={() => {
                add();
                scrollToAddButton();
              }}
            >
              Add
            </Button>
          </>
        )}
      </Form.List>
    </>
  );
};

export default FormListComp;
